module.exports = __webpack_public_path__ + "static/media/Cloud_Base.df68860c.png";